import { InjectionToken } from '@tanbo/vue-di-plugin'
export enum SystemType {
  Windows = 1,
  Linux,
  WinServer
}
export const SystemTypeInjectionToken = new InjectionToken<SystemType>('SystemTypeInjectionToken')
export const SystemCategoryName = {
  1: 'category',
  2: 'linux_category'
}
export const HandleTypeUpdateFunctionMap = {
  1: 'updateAutoIDs',
  2: 'updateNotifyIDs',
  3: 'updateIgnoreIDs'
}
export interface RepairTreeItem {
  name: string,
  id: string,
  // 1-自动 2-手动 3-不需处理
  handle_type?: number,
  // 0-无 1-常规
  scan_level?: number,
  // 二级名
  fatherName: string
  items: RepairTreeItem[]
}
export interface AllBaseLineItemResponse {
  category: RepairTreeItem[],
  linux_category?: RepairTreeItem[],
  nums: number,
  linux_nums: number,
  version: string
}
export enum HandleType {
  AUTO = 1,
  NOTIFY,
  IGNORE
}
export enum ScanLevelType {
  ALL,
  NORMAL,
  CUSTOM
}
export enum SYSTEM_TYPE {
  WINDOWS = 1,
  LINUX,
}

/** 与 locales 中 `baselineRepairItems.n` 下键一致：id `1.1.1` → `baselineRepairItems.n.1_1_1` */
export function baselineRepairNameI18nKey (id: string): string {
  const suf = String(id).replace(/\./g, '_')
  return `baselineRepairItems.n.${suf}`
}

/** 本地静态树已无展示文案；展示名取自接口缓存字段 + 上式 i18n。 */
export const repairItemsCategory = {
    "category": [
        {
            "id": "1",
            "name": "",
            "items": [
                {
                    "id": "1.1",
                    "name": "",
                    "items": [
                        {
                            "id": "1.1.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "1.1.2",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        },
                        {
                            "id": "1.1.3",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        },
                        {
                            "id": "1.1.4",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "1.1.5",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        },
                        {
                            "id": "1.1.6",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "1.2",
                    "name": "",
                    "items": [
                        {
                            "id": "1.2.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "1.2.2",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "1.2.3",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        }
                    ]
                }
            ]
        },
        {
            "id": "2",
            "name": "",
            "items": [
                {
                    "id": "2.1",
                    "name": "",
                    "items": [
                        {
                            "id": "2.1.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        },
                        {
                            "id": "2.1.2",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "2.1.3",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        },
                        {
                            "id": "2.1.4",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "2.1.5",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "2.2",
                    "name": "",
                    "items": [
                        {
                            "id": "2.2.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 0
                        }
                    ]
                },
                {
                    "id": "2.3",
                    "name": "",
                    "items": [
                        {
                            "id": "2.3.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 0
                        }
                    ]
                },
                {
                    "id": "2.4",
                    "name": "",
                    "items": [
                        {
                            "id": "2.4.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "2.5",
                    "name": "",
                    "items": [
                        {
                            "id": "2.5.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "2.5.2",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "2.6",
                    "name": "",
                    "items": [
                        {
                            "id": "2.6.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "2.6.2",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        }
                    ]
                }
            ]
        },
        {
            "id": "3",
            "name": "",
            "items": [
                {
                    "id": "3.1",
                    "name": "",
                    "items": [
                        {
                            "id": "3.1.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        }
                    ]
                },
                {
                    "id": "3.2",
                    "name": "",
                    "items": [
                        {
                            "id": "3.2.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "3.2.2",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "3.2.3",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "3.2.4",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "3.2.5",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "3.2.6",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "3.2.7",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        },
                        {
                            "id": "3.2.8",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        }
                    ]
                },
                {
                    "id": "3.3",
                    "name": "",
                    "items": [
                        {
                            "id": "3.3.1",
                            "name": "",
                            "handle_type": 3,
                            "scan_level": 0
                        },
                        {
                            "id": "3.3.2",
                            "name": "",
                            "handle_type": 3,
                            "scan_level": 0
                        },
                        {
                            "id": "3.3.3",
                            "name": "",
                            "handle_type": 3,
                            "scan_level": 0
                        }
                    ]
                }
            ]
        },
        {
            "id": "4",
            "name": "",
            "items": [
                {
                    "id": "4.1",
                    "name": "",
                    "items": [
                        {
                            "id": "4.1.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        },
                        {
                            "id": "4.1.2",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "4.2",
                    "name": "",
                    "items": [
                        {
                            "id": "4.2.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "4.3",
                    "name": "",
                    "items": [
                        {
                            "id": "4.3.1",
                            "name": "",
                            "handle_type": 1,
                            "scan_level": 0
                        }
                    ]
                },
                {
                    "id": "4.4",
                    "name": "",
                    "items": [
                        {
                            "id": "4.4.1",
                            "name": "",
                            "handle_type": 3,
                            "scan_level": 1
                        }
                    ]
                }
            ]
        }
    ],
    "linux_category": [
        {
            "id": "101",
            "name": "",
            "items": [
                {
                    "id": "101.1",
                    "name": "",
                    "items": [
                        {
                            "id": "101.1.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "101.2",
                    "name": "",
                    "items": [
                        {
                            "id": "101.2.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "101.3",
                    "name": "",
                    "items": [
                        {
                            "id": "101.3.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "101.3.2",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "101.3.3",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "101.4",
                    "name": "",
                    "items": [
                        {
                            "id": "101.4.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "101.4.2",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "101.4.3",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "101.4.4",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "101.4.5",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                }
            ]
        },
        {
            "id": "102",
            "name": "",
            "items": [
                {
                    "id": "102.1",
                    "name": "",
                    "items": [
                        {
                            "id": "102.1.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "102.2",
                    "name": "",
                    "items": [
                        {
                            "id": "102.2.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "102.3",
                    "name": "",
                    "items": [
                        {
                            "id": "102.3.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "102.3.2",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "102.4",
                    "name": "",
                    "items": [
                        {
                            "id": "102.4.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "102.5",
                    "name": "",
                    "items": [
                        {
                            "id": "102.5.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "102.5.2",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                }
            ]
        },
        {
            "id": "103",
            "name": "",
            "items": [
                {
                    "id": "103.1",
                    "name": "",
                    "items": [
                        {
                            "id": "103.1.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.1.2",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.1.3",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.1.4",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "103.2",
                    "name": "",
                    "items": [
                        {
                            "id": "103.2.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.2.2",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.2.3",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.2.4",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.2.5",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.2.6",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.2.7",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        },
                        {
                            "id": "103.2.8",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                }
            ]
        },
        {
            "id": "104",
            "name": "",
            "items": [
                {
                    "id": "104.1",
                    "name": "",
                    "items": [
                        {
                            "id": "104.1.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                },
                {
                    "id": "104.2",
                    "name": "",
                    "items": [
                        {
                            "id": "104.2.1",
                            "name": "",
                            "handle_type": 2,
                            "scan_level": 1
                        }
                    ]
                }
            ]
        }
    ],
    "version": "1.0.4",
    "nums": 37,
    "linux_nums": 31
}
